// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"BZ-z","smallCardRow":"CZ-z","largeCardRow":"DZ-z","productSearchRow":"EZ-z","curatedRow":"FZ-z"};